<template>
	<div>
		<!-- Begin Page Content -->
        <div class="Diebetes-Program">
            <div class="row">
                <div class="col-12 mb-4 pl-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-3">
                            <h2 class="d-flex align-items-center">
                                <router-link to="/add-prescription"><i class="icon icon-chevron-down"></i> Add Medicine to Diebetes Program</router-link>
                            </h2>
                            <div class="row no-gutters justify-content-center mt-4">
                                <div class="col-lg-10">
                                    <form class="add-medicine text-center">
                                        <div class="input-group mb-4">
                                            <input type="text" name="text" placeholder="Azulix O MF Forte " />
                                        </div>
                                        <div class="input-group mb-4 d-flex justify-content-between align-items-center" style="displaynone">
                                            <p class="mb-0">Have you taken the medicine before?</p>
                                            <div class="switch d-flex"><input type="checkbox" id="switch" /><label for="switch" class="mb-0">Toggle</label></div>
                                        </div>

                                        <div class="row mb-4" style="display: none;">
                                            <div class="col-lg-6">
                                                <div class="input-group">
                                                    <input type="text" name="text" placeholder="No of Tablet" />
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="input-group">
                                                    <input type="text" name="text" placeholder="500 mg" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group mb-4 d-flex justify-content-between align-items-center" style="display: none !important;">
                                            <p class="mb-0">Did you face any side Effect</p>
                                            <div class="switch d-flex"><input type="checkbox" id="switch-1" /><label for="switch-1" class="mb-0">Toggle</label></div>
                                        </div>
                                        <div class="input-group mb-4" style="display: none;">
                                            <textarea rows="0" placeholder="Please describe"></textarea>
                                        </div>
                                        <div class="row mb-4">
                                            <div class="col-lg-6">
                                                <div class="input-group">
                                                    <input type="text" name="text" placeholder="No of Tablet" />
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="input-group">
                                                    <input type="text" name="text" placeholder="500 mg" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group mb-4">
                                            <input type="text" name="text" placeholder="No of Days" />
                                        </div>
                                        <router-link  class="btn btn-blue Medicine-List mt-1" to="/mannual-prescription">Add Medicine to List</router-link>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-12 mb-4 text-left prescription-name">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-3 text-left">
                            <h2>Azulix O MF Forte</h2>
                            <figure><img src="../../../../static/website/images/Azulix-O-MF-Forte.svg" /></figure>
                            <div class="text-left">
                                <h3>Manufacturer</h3>
                                <p>Torrent Pharmaceuticals Ltd</p>
                                <h3>Salt Composition</h3>
                                <p>Glimepiride (1mg) + Metformin (1000mg)</p>
                                <h3>Storage</h3>
                                <p>Store below 30°C</p>
                                <h3>Uses of Azulix MF Tablet PR</h3>
                                <p>Type 2 Diabetes Mellitus</p>
                            </div>
                            <router-link to="/prescription-product" class="click-here">Click Here to know more</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Diebetes-list-section">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="bg-white border-radius-5 p-4">
                        <div class="card-body bg-white border-radius-5 p-0 h-100">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h2>Your Diebetes List</h2>
                                <router-link class="btn btn-blue Create-Prescription" to="/prescription-list">Create Prescription List</router-link>
                            </div>
                            <div class="table-responsive">
                                <table class="table Medicine-list mb-0 border-0" border="0" cellspacing="0" cellpadding="0">
                                    <thead>
                                        <tr>
                                            <th>Medicine Name</th>
                                            <th>Dosage</th>
                                            <th>Duration</th>
                                            <th>&nbsp;</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><span>1. Ceruvin 75</span></td>
                                            <td>2 times(Morning and Evening )</td>
                                            <td>10 Days, Total Tablet : 10</td>
                                            <td><router-link to="/prescription-product">Analyze your medicine</router-link></td>
                                            <td><i class="icon icon-close"></i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
	</div>
</template>
<script>
	export default {
        name: 'Mannual-prescription',
        data () {
            return {
                

            }
        },
        created(){
           this.pageName('Add Prescription')
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/Mannual-prescription.vue